/** Clave por guía (?guide=ai → id `ai`) para no volver a abrir el modal automáticamente. */
const STORAGE_PREFIX = "wembii.productGuide.dismissed.";

export function isProductGuideDismissed(guideId: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_PREFIX + guideId) === "1";
  } catch {
    return false;
  }
}

export function dismissProductGuide(guideId: string): void {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + guideId, "1");
  } catch {
    /* ignore quota / private mode */
  }
}
